import { createFileRoute } from "@tanstack/react-router";

import { Contato } from "@/components/itv/pages/Contato";
import { JsonLd } from "@/components/seo/JsonLd";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { breadcrumbSchema } from "@/lib/schema";

const PATH = "/contato/";
const TITLE = "Contato e Agendamento de Consulta | Dr. Thiago Viana";
const DESCRIPTION =
  "Fale com o consultório do Dr. Thiago Viana em Bauru: endereço, telefone, e-mail e agendamento de consulta presencial ou teleconsulta pelo WhatsApp.";

export const Route = createFileRoute("/contato")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

const trilha = [
  { nome: "Home", path: "/" },
  { nome: "Contato", path: PATH },
];

function Page() {
  return (
    <>
      <JsonLd data={breadcrumbSchema(trilha)} />
      <Contato />
    </>
  );
}
